import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../Config/Hooks';
import { getFirstAccessibleSettingsRoute } from '../../Utils/SettingsRouteUtils';

export default function SettingsHomePage() {
    const account = useAppSelector(state => state.authentication.account);
    const defaultRoute = getFirstAccessibleSettingsRoute(account?.authoritySet ?? []);
    return <Navigate to={defaultRoute} replace />;
}
